import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetObjectiveNormalDefaultsQuery,
  GetObjectiveNormalDefaultsQueryVariables,
} from "./ObjectiveNormalDefaults.generated";

export const GET_OBJECTIVE_NORMAL_DEFAULTS: TypedDocumentNode<
  GetObjectiveNormalDefaultsQuery,
  GetObjectiveNormalDefaultsQueryVariables
> = gql`
  query GetObjectiveNormalDefaults {
    user {
      uuid
      objectiveNormalDefaults {
        uuid
        shouldUse
        temperature
        heartRate
        weight
        respiratoryRate
        capillaryRefillTime
        hydrationStatus
        bodyConditionScore
        painScore
        fearAnxietyStressScore
        eyes
        ears
        oralDental
        cardiovascular
        respiratory
        neurological
        musculoskeletal
        lymphatic
        gastrointestinal
        reproductiveUrinary
        furSkin
        nasal
        masses
        mucousMembranes
      }
    }
  }
`;
